module.exports = __webpack_public_path__ + "img/back5.00802bb8.png";